import privacy from '../commonAssets/beemPrivacyText';
import deleteAccountText from '../commonAssets/deleteAccountText';
import terms from '../commonAssets/termsText';
import chatLogo from './assets/chat_logo.svg';
import opIcon from './assets/efg-op-icon.svg';
import favicon from './assets/favicon.svg';
import imprint from './assets/imprintText';
import logo from './assets/logo.svg';
import simpleLogo from './assets/simple_logo.svg';

const config = {
  title: 'EFG BEEM',
  description:
    'BEEM ermöglicht es dem Fachhandwerk, unkompliziert und zu jederzeit ihrem persönlichen EFG-Ansprechpartner Fragen zu stellen – und das rechtssicher!',
  identifier: 'efg',
  appName: 'EFG',
  defaultBrand: 'EFG',
  url: 'efgbeem.de',
  apiBaseUrl: 'https://api.efgbeem.de',
  helpUrl: 'https://hilfe.getbeem.de/',
  iosStoreUrl: 'https://apps.apple.com/us/app/efg-beem/id1612675009',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=de.efgbeem',
  supportEmail: 'support@getbeem.de',
  favicon,
  logo,
  chatLogo,
  simpleLogo,
  packageId: 'de.efgbeem',
  privacyText: privacy,
  termsText: terms,
  usercentricsId: 'uohzQruE2',
  imprintText: imprint,
  deleteAccountText,
  welcomeText: 'Willkommen bei EFG BEEM!',
  identifierPlaceholder: 'Mobilnummer oder E-Mail Adresse',
  mainText: 'Bitte geben Sie Ihre Mobilnummer oder E-Mail Adresse ein, um sich anzumelden.',
  opIcon,
};

export default config;
